import React from 'react';
import { useIsMobile } from 'app/hooks/useIsMobile';
import SharedEquipment from './SharedEquipment';
import SharedFleets from './SharedFleets';
import useGetEquipmentData from 'app/hooks/useGetEquipmentData';

function EquipmentAndFleets() {
  const isMobile = useIsMobile();

  const { sharesData } = useGetEquipmentData();

  return (
    <div>
      <SharedEquipment
        isMobile={isMobile}
        sharedEquipment={sharesData?.equipment ?? []}
      />
      <SharedFleets
        isMobile={isMobile}
        sharedFleets={sharesData?.fleets ?? []}
      />
    </div>
  );
}

export default EquipmentAndFleets;
